/*
 * Copyright (c) 2021. Legalbird eine Marke der R+S Internet Jewels GmbH
 */
import React, { useState } from "react";
import ButtonLoading from "../Button/ButtonLoading";
import Grid from "@mui/material/Grid";
import ValidatorSelect from "../Validator/ValidatorSelect";
import MenuItem from "@mui/material/MenuItem";
import useForm from "../../hooks/useForm";
import { formValue } from "../../services/formServiceFunctions";
import ApiClient from "../../services/ApiClient";
import { useSnackbar } from "notistack";

import { requiredFieldDefault } from "../../services/validationRules";
import { Checkbox, FormControlLabel } from "@mui/material";
import usePartnerRegistry from "../../hooks/usePartnerRegistry";

const ControllingForm = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { partnersBySlug, isLoading: isPartnerRegistryLoading } = usePartnerRegistry();

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async ({ values }: { values: Record<string, any> }) => {
    setIsLoading(true);
    const data = await ApiClient.post("services/controlling/partner_controlling", {
      body: JSON.stringify({
        partner: values.partner,
        month: values.month,
        year: values.year,
        dryrun: values.dryrun,
      }),
    });
    if (data && data.status) {
      if (data.parentFolderId) {
        enqueueSnackbar(data.message, {

          variant: "custom",
          buttonText: "zum Dokument",
          buttonLink: "https://drive.google.com/drive/folders/" + data.parentFolderId,
          linkIsExternal: true,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
        });
      }
      setIsLoading(false);
    }
  };
  const { values, handleChange, handleSubmit } = useForm({
    initialValues: {
      partner: "",
      month: "",
      year: "",
      dryrun: true,
    },
    onSubmit,
  });

  if (isPartnerRegistryLoading) {
    return null;
  }

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3} sx={{
        alignItems: "center"
      }}>
        <Grid
          size={{
            xs: 12,
            md: 6,
            lg: 3
          }}>
          <ValidatorSelect
            label={"Partner"}
            name={"partner"}
            value={formValue(values, "partner")}
            helperText={"Partner für die Abrechnung"}
            onChange={handleChange}
            validators={requiredFieldDefault}
          >
            {partnersBySlug.wbs && <MenuItem value={"wbs"}>{partnersBySlug.wbs.brandName || partnersBySlug.wbs.name}</MenuItem>}
            <MenuItem value={"all"}>Alle</MenuItem>
          </ValidatorSelect>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
            lg: 2
          }}>
          <ValidatorSelect
            label={"Monat"}
            name={"month"}
            value={formValue(values, "month")}
            helperText={"Monat Abrechnungszeitraum"}
            onChange={handleChange}
            validators={requiredFieldDefault}
          >
            <MenuItem value={1}>Januar</MenuItem>
            <MenuItem value={2}>Februar</MenuItem>
            <MenuItem value={3}>März</MenuItem>
            <MenuItem value={4}>April</MenuItem>
            <MenuItem value={5}>Mai</MenuItem>
            <MenuItem value={6}>Juni</MenuItem>
            <MenuItem value={7}>Juli</MenuItem>
            <MenuItem value={8}>August</MenuItem>
            <MenuItem value={9}>September</MenuItem>
            <MenuItem value={10}>Oktober</MenuItem>
            <MenuItem value={11}>November</MenuItem>
            <MenuItem value={12}>Dezember</MenuItem>
          </ValidatorSelect>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
            lg: 2
          }}>
          <ValidatorSelect
            label={"Jahr"}
            name={"year"}
            value={formValue(values, "year")}
            helperText={"Jahr Abrechnungszeitraum"}
            onChange={handleChange}
            validators={requiredFieldDefault}
          >
            <MenuItem value={2024}>2024</MenuItem>
            <MenuItem value={2025}>2025</MenuItem>
            <MenuItem value={2026}>2026</MenuItem>
          </ValidatorSelect>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
            lg: 2
          }}>
          <FormControlLabel
            control={<Checkbox name={"dryrun"} checked={formValue(values, "dryrun")} onChange={handleChange} />}
            label={"Dry Run"}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
            lg: 3
          }}>
          <ButtonLoading
            isLoading={isLoading}
            disabled={isLoading}
            type={"submit"}
            color={"primary"}
            variant={"contained"}
            fullWidth={true}
          >
            Abrechnung erstellen
          </ButtonLoading>
        </Grid>
      </Grid>
    </form>
  );
};

export default ControllingForm;
